import axios from 'axios';

export default {
  getUserAccess: (userId) => axios.get(`/api/v1/view/structure/user-access/${userId}`),
  getTeamAccess: (teamId) => axios.get(`/api/v1/view/structure/team-access/${teamId}`),
  updateUserAccess: ({ userId, structureId }) => axios.put(`/api/v1/view/structure/${structureId}/user-access/${userId}`),
  updateUserAllAccess: ({ userId, value }) => axios.put(`/api/v1/view/structure/${value}/all-user-access/${userId}`),
  updateTeamAccess: ({ teamId, structureId }) => axios.put(`/api/v1/view/structure/${structureId}/team-access/${teamId}`),
  updateTeamAllAccess: ({ teamId, value }) => axios.put(`/api/v1/view/structure/${value}/all-team-access/${teamId}`),
  updateUserFullAccess: ({ userId, value }) => axios.put(`/api/v1/view/structure/full-user-access/${userId}`, { value }),
  updateTeamFullAccess: ({ teamId, value }) => axios.put(`/api/v1/view/structure/full-team-access/${teamId}`, { value }),
};
